import SpeechLabTag from './SpeechLabTag.vue';

export default {
  SpeechLabTag,
};
